import { TextField, Typography } from "@material-ui/core";
import React, { Component, Fragment } from "react";
import {
  extractImageValue,
  extractTextAnswerValue,
  extractAiFlags,
} from "../../store/form.answer.extract";
import { textAnswer } from "../../store/form.answer.fill";
import { openSectionState, currentSectionState } from "../../store/form.store";
import { AiStatusOverlay } from "../../../components/AiStatusOverlay";
import { withStyles } from "@material-ui/styles";

const styles = (theme) => ({
  container: {
    wordBreak: "break-word",
    overflowWrap: "break-word",
    whiteSpace: "normal",
  },
});

export class SingleLineInput extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: "",
      // helpTextValue: "",
      imageValue: [],
      editable: false,
      aiFlags: {},
    };
  }

  componentDidMount() {
    let expanded = "";
    this.sectionStateSubscription = openSectionState.subscribe((sectionId) => {
      expanded = sectionId;
    });
    this.currentSectionSubscription = currentSectionState.subscribe(
      (section) => {
        this.setState({ editable: section === expanded });
      },
    );
    this.onLoadPage(this.props);
    // if (this.props.element.properties.answerLabel) {
    //   this.onLoadHelpText(this.props);
    // }
    if (this.props.element.properties.allowFileUpload) {
      this.onLoadImage(this.props);
    }
  }

  componentWillUnmount() {
    this.sectionStateSubscription.unsubscribe();
    this.currentSectionSubscription.unsubscribe();
  }

  onLoadPage(props) {
    if (props.element) {
      let answer = props.element.answer;
      let userResponse = extractTextAnswerValue(answer);
      if (userResponse) {
        this.setState({
          value: userResponse,
        });
      }
    }
  }

  // onLoadHelpText(props) {
  //   const answerLabel = props.element.properties.answerLabel;
  //   if (answerLabel) {
  //     this.setState({ helpTextValue: answerLabel });
  //   }
  // }

  onLoadImage(props) {
    if (props.element) {
      let image = props.element.answer;
      let imageResponse = extractImageValue(image);
      if (imageResponse) {
        this.setState({
          imageValue: imageResponse,
        });
      }
      this.setState({ aiFlags: extractAiFlags(props.element.answer) });
    }
  }

  onChange = (event) => {
    this.setState({ value: event.target.value });
    let answerNode = textAnswer(
      event.target.value,
      this.props?.element?.answer
    );
    if (this.props.onChange !== undefined) {
      this.props.onChange(answerNode, this.props.element);
    }
  };

  render() {
    const { classes } = this.props;
    return (
      <Fragment>
        {this.state.editable ? (
          <TextField
            id="textField"
            fullWidth
            required
            variant="outlined"
            error={this.props.hasError}
            value={this.state.value}
            onChange={this.onChange}
          />
        ) : (
          <Typography className={classes.container}>
            {this.state.value}
          </Typography>
        )}
        {/* {this?.state?.helpTextValue && (
          <FormHelperText>{this.state.helpTextValue}</FormHelperText>
        )} */}
        {this.props.element.properties.allowFileUpload &&
        this.state.imageValue.length > 0 ? (
          <AiStatusOverlay
            imageList={this.state.imageValue}
            aiVerificationStatus={this.state.aiFlags.aiVerificationStatus}
            aiVerificationMessage={this.state.aiFlags.aiVerificationMessage}
          />
        ) : null}
      </Fragment>
    );
  }
}
export default withStyles(styles, { withTheme: true })(SingleLineInput);
